import { useStyles } from "./ShopBundleInventory.style";
import { Inventory } from "@onmo/graphql/graphql";
import ShopBundle from "../../core/ShopBundle/ShopBundle";
import { useFetchBundlesInventory } from "../../../hooks/resolvers/useShopQuery";
import { useAppDispatch } from "../../../hooks";
import { setOpenBundle } from "../../../slices/shop";
import { Typography, TypographyVariant } from "@onmo/ui";
import { useTranslation } from "react-i18next";

const ShopBundleInventory: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { bundlesInventory } = useFetchBundlesInventory();

  return (
    <div className={classes.tabContent}>
      <div className={classes.tabTitle}>
        <Typography variant={TypographyVariant.HeadingH6Bold}>
          {t("shop_bundles")}
        </Typography>
      </div>
      <div className={classes.listBundles}>
        {bundlesInventory?.map((item: Inventory) => {
          if (item.isPurchased) return null;
          return (
            <ShopBundle
              inventory={item}
              fullWidth
              onClick={() => dispatch(setOpenBundle({ openBundle: item }))}
            />
          );
        })}
      </div>
    </div>
  );
};
export default ShopBundleInventory;
